import Lookup from 'src/componentes/select2';

const FrequenciaRecorrenciaFormularioGlobalLookup = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/FrequenciaRecorrenciaFormularioGlobalLookup"
    {...rest}
  />
);

export default FrequenciaRecorrenciaFormularioGlobalLookup;
